import { observer } from 'mobx-react-lite';
import numeral from 'numeral';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Importer } from '@feathr/blackbox';
import { Text } from '@feathr/components';

import { getPartialImportCounts } from './ImportRunDetails.utils';

interface IPartialImportLineProps {
  importer: Importer;
}

/** How many of the rows it read a run imported, when it did not import them all. */
function PartialImportLine({ importer }: Readonly<IPartialImportLineProps>): JSX.Element | null {
  const { t } = useTranslation();

  const counts = getPartialImportCounts(importer);
  if (!counts) {
    return null;
  }

  const imported = t('We imported {{imported}} of {{formattedTotal}} rows into {{- name}}.', {
    count: counts.total,
    formattedTotal: numeral(counts.total).format('0,0'),
    imported: numeral(counts.imported).format('0,0'),
    name: importer.name,
  });
  const notImported = t('The other {{formattedCount}} were not imported.', {
    count: counts.skipped,
    formattedCount: numeral(counts.skipped).format('0,0'),
  });

  // Placeholder copy, pending Product and Design.
  return (
    <Text.DefaultRegular>
      {counts.skipped > 0 ? `${imported} ${notImported}` : imported}
    </Text.DefaultRegular>
  );
}

export default observer(PartialImportLine);
